import { FC, useEffect, useState } from "react";
import { ReactComponent as ClockIcon } from "images/Clock.svg";
import cn from "classnames";
import Tooltip from "components-new/Tooltip";
import styles from "./Clock.module.sass";
import { IObject } from "toolkit/steps/stepSix/stepSix.types";
import { convertDate, declOfLessonsNum } from "helpers";

interface IClock {
	value: string;
	color: string;
	description: string;
}

interface ClockProps {
	object: IObject;
	description?: boolean;
}

export const Clock: FC<ClockProps> = ({ object, description }) => {
	const [clockData, setClockData] = useState<IClock>({
		value: "",
		color: "",
		description: "",
	});

	useEffect(() => {
		if (!object.timeToSend && object.timeToSend !== 0) return;
		const milliseconds = Math.abs(object.timeToSend);
		const hoursFloor = Math.floor(milliseconds / 3600000);
		const hoursCeil = Math.ceil(milliseconds / 3600000);
		const daysFloor: number = Math.floor(hoursFloor / 24);
		let result = "";
		if (daysFloor && hoursFloor - daysFloor * 24) {
			result = `${daysFloor} ${declOfLessonsNum(daysFloor, ["день", "дня", "дней"])}, ${
				hoursFloor - daysFloor * 24
			} ${declOfLessonsNum(hoursFloor - daysFloor * 24, ["час", "часа", "часов"])}`;
		} else if (daysFloor && !(hoursFloor - daysFloor * 24)) {
			result = `${daysFloor} ${declOfLessonsNum(daysFloor, ["день", "дня", "дней"])}`;
		} else if (!daysFloor && hoursCeil) {
			result = `${hoursFloor - daysFloor * 24} ${declOfLessonsNum(hoursCeil, ["час", "часа", "часов"])}`;
		}
		if (hoursFloor >= 72) {
			setClockData({
				value: result,
				color: "blue",
				description: "Осталось 3\u201110 дней",
			});
		} else if (hoursFloor >= 0 && hoursFloor < 72) {
			setClockData({
				value: result,
				color: "yellow",
				description: "Осталось менее 3 дней",
			});
		}

		if (object.timeToSend < 0) {
			setClockData({
				value: `Просрочено на ${result}`,
				color: "red",
				description: "Просрочено",
			});
		}
		//eslint-disable-next-line
	}, []);

	return (
		<>
			<Tooltip
				delay={200}
				menu={
					<div className={styles.tooltip}>
						<div className={styles["tooltip-item"]}>
							<span className={styles["tooltip-item-title"]}>Осталось</span>
							<span className={styles["tooltip-item-value"]}>{clockData.value}</span>
						</div>
						<div className={styles["tooltip-item"]}>
							<span className={styles["tooltip-item-title"]}>Дата утверждения</span>
							<span className={styles["tooltip-item-value"]}>{convertDate(object.approvalDate!)}</span>
						</div>
					</div>
				}
				color="themeWhite">
				<div className={cn(styles["clock-icon"], styles[`clock-icon-${clockData.color}`])}>
					<ClockIcon />
				</div>
			</Tooltip>
			{description && (
				<span className={cn(styles.description, styles[`description-${clockData.color}`])}>
					{clockData.description}
				</span>
			)}
		</>
	);
};
